export var CSResume = {
  subscriptionInfo: {
    header: 'Resume subscription',
    subHeader: '',
    billingCadence: {
      monthly: '/mo.',
      semiAnnual: '/mo.',
      annual: '/yr.'
    }
  },
  cta: {
    cta: 'Resume',
    cancelButtonText: 'Cancel',
    secondaryCta: 'Cancel'
  },
  termsAndConditions: {
    contentTitle: 'See terms and conditions',
    content: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'You can cancel your subscription anytime by visiting My Account on Chegg.com, clicking "Cancel," and completing the steps to cancel. Your Chegg Study subscription begins today and renews automatically. Subscription fees are not refundable and unused subscription benefits expire and do not roll over to subsequent months.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    link: ' See terms and conditions',
    backButtonText: 'Back to checkout',
    tncPromptText: 'You can cancel your subscription anytime by visiting My Account on Chegg.com, clicking "Cancel," and completing the steps to cancel. Your Chegg Study subscription begins today and renews automatically. Subscription fees are not refundable and unused subscription benefits expire and do not roll over to subsequent months.',
    tncPromptTextWithCoupon: '',
    cheggTermsOfUseText: 'Chegg Terms of Use',
    cheggTermsOfUseLink: '/termsofuse',
    privacyPolicyText: 'Privacy Policy',
    privacyPolicyLink: '/privacypolicy'
  },
  orderManagementInfo: {
    orderManagementInfo: "It's only __${price}__ + applicable tax to resume your subscription. Your ${card} ending in __${last4digits}__ will be charged today.",
    orderManagementInfoNonCreditCard: "It's only __${price}__ + applicable tax to resume your subscription. __${description}__ will be charged today.",
    orderManagementInfoYiftee: "It's only __${price}__ + applicable tax to resume your subscription. Your __scholarship balance__ will be charged today.",
    orderManagementInfoUpi: 'If you choose to proceed, your subscription will be automatically renewed on ${date} and ${img} __${vpa}__ will be charged __${price}__ + applicable tax.'
  },
  buttonConditions: {
    buttonConditions: 'By clicking ${cta} you consent to Chegg automatically charging the payment method on file ${price} per month (+ applicable tax) each month until you cancel.  \n'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/constants/ContentfulFallback/CSResume.js
// module id = 4186
// module chunks = 11